import React from 'react'
import styled from "styled-components";
const Truested = () => {
  return (
    <Wrapper className="brand-section">
    <div className="container">
      <h3>Trusted By 1000+ Companies</h3>
      <div className="brand-section-slider pad">

        <div className="slide" style={{display:"flex",justifyContent:"space-around"}}>
          <img
            src="https://img.freepik.com/free-vector/elegant-circle-logo-icon_126523-971.jpg"
            alt="trusted-brands"
          />
        </div>
        <div className="slide">
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRswu6MSBNNXlO67iE784EYngAPBPTfEanywzP2h7VROWTtWgF2AqQvxH25QAxafcMSGts&usqp=CAU"
            alt="trusted-brands"
          />
        </div>
        <div className="slide">
          <img
            src="https://media.istockphoto.com/id/1201144331/vector/icon-design-element-logo-for-technology-innovation-company-tech-icon-and-symbol.jpg?s=612x612&w=0&k=20&c=Q-zPPtCY9aNohWqcUTB-rEBSd3xoC6fqSEgWDgulrf8="
            alt="trusted-brands"
          />
        </div>
        <div className="slide">
          <img
            src="https://images.examples.com/wp-content/uploads/2019/06/Company-Logo-Design.jpg"
            alt="trusted-brands"
          />
        </div>
        <div className="slide">
          <img
            src="https://d1csarkz8obe9u.cloudfront.net/posterpreviews/corporate-company-logo-design-template-2402e0689677112e3b2b6e0f399d7dc3_screen.jpg?ts=1561532453"
            alt="trusted-brands"
          />
          
        </div>
      </div>
    </div>
  </Wrapper>
  )
}

const Wrapper = styled.section`
  padding: 9rem 0;
  background-color: ${({ theme }) => theme.colors.bg};
  .brand-section {
    padding: 12rem 0 0 0;
  }
.pad{
  margin-left: -50px;
}

  h3 {
    text-align: center;
    text-transform: capitalize;
    color: ${({ theme }) => theme.colors.text};
    font-size: 2rem;
    font-weight: bold;
  }
  img {
    min-width: 20rem;
    height: 20rem;
    mix-blend-mode : multiply;
  }
  .brand-section-slider {
    margin-top: 3.2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
  }
  @media (max-width: ${({ theme }) => theme.media.mobile}) {
    .brand-section-slider {
      margin-top: 3.2rem;
      display: grid;
      grid-template-columns: 1fr 1fr;
      /* background-color: red; */
      text-align: center;
    }
  }
`;
export default Truested
